<template>
	<div class="content-gift">
		<div class="header-gift" v-bind:style="{ backgroundColor: color_licencia }">
			<h4>Pedido realizado por:</h4>
			<h4>{{ send_nombre }}</h4>
		</div>
		<div class="data-gift">
			<div class="order-owner">
				<h4>Información de entrega</h4>
			</div>
			<div class="data-receptor">
				<input type="text" id="name" class="data-name" v-model="form.reciber_name" placeholder="Nombre de quien recibe" autocomplete="off">
				<div class="phone-day">
					<input type="text" id="phone" class="data-phone" v-model="form.reciber_phone" placeholder="Celular" autocomplete="off">
					<input type="date" id="day" class="data-deliver-day" v-model="form.delivery_day" placeholder="Día de entrega" autocomplete="off" onchange="this.className=(this.value!=''?'has-value':'')">
				</div>
				<input type="text" id="addreess" class="data-address" v-model="form.reciber_adress" placeholder="Dirección completa de entrega" autocomplete="off">
				<div class="place-hour">
					<input type="text" id="barrio" class="data-place" v-model="form.reciber_place" placeholder="Barrio" autocomplete="off">
					<input type="time" id="hour" class="data-clock" v-model="form.delivery_hour" placeholder="Hora de entrega" autocomplete="off" v-if="reciber_hour" onchange="this.className=(this.value!=''?'has-value':'')">
				</div>
				<input type="text" id="message" class="data-message" v-model="form.delivery_message" placeholder="Mensaje para la tarjeta (Max. 15 pal.)" autocomplete="off" v-on:keydown="key">
				<h4 id="limit">¡El límite son 15 palabras!</h4>
				<div class="check-name">
					<h4>¿La tarjeta se firma con tu nombre?</h4>
					<div class="inputGroup2" @click="form.nofirm = false;form.firm = true;">
    					<input v-model="form.firm"  type="checkbox"/>
    					<label for="option1">Si</label>
  					</div>
  					<div class="inputGroup2" @click="form.firm = false;form.nofirm = true;">
    					<input v-model="form.nofirm"  type="checkbox"/>
    					<label for="option1">No</label>
  					</div>
				</div>
				<div class="send-image" v-show="show_image">					
					<input v-on:change="uploadImage()" type="file" name="file" id="file" class="inputfile"/>
					<label for="file"><i class="fas fa-camera"></i> Subir imagen de muestra</label>
					<i v-show="statusImagen" class="fas fa-check"></i>
					<i v-show="statusImagen" class="fas fa-trash-alt" @click="deleteImage()"></i>
				</div>
				<div v-show="!show_image">
					<br>
				</div>
			</div>
			<div class="options-buttons">
				<div class="back-btn">
					<button @click="back()">Volver</button>
				</div>
				<div class="finish-order" v-bind:style="{ backgroundColor: color_licencia }">
					<button @click="confirmOrder()">Finalizar</button>
				</div>
			</div>
		</div>
	</div>
</template>	

<style lang="scss" scoped>
	@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

	*:focus{
		outline:none;
	}

	#limit{
		font-size: 13px;
		font-weight: 500;
		padding: 7px 0px;
		width:100%;
		color: red;
	}

	.no-reciber-hour{
		width:100% !important;
	}

	.empty-shield{
		border: 2px solid red !important;
	}

	.fa-trash-alt{
		font-size:23px;
		color:red !important;
		margin-left: 5px;
	}

	.fa-check{
		font-size:23px;
		color:green !important;
		margin-left: 15px;
	}

	input[type="date"]:not(.has-value):before{
  		color: #757575;
 		content: attr(placeholder);
	}

	input[type="time"]:not(.has-value):before{
  		color: #757575;
 		content: attr(placeholder);
	}

	input[type="file"]{
		border:none !important;
		background: transparent !important;
	}
	
	.inputfile {
		width: 0.1px;
		height: 0.1px;
		opacity: 0;
		overflow: hidden;
		position: absolute;
		z-index: -1;
	}

	.inputfile + label {
	    font-size: 15px;
	    font-weight: 500;
	    padding: 11px 25px;
	    font-family: 'Poppins', sans-serif;
	    color: white;
	    background: #5E49DA;
	    display: inline-block;
	}

	.inputfile + label {
		cursor: pointer;
	}


	.header-gift{
		width: 100%;
		padding: 20px 15px;
		/*background: url("/fondo.png");*/
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center center;
		display: flex;
		justify-content: flex-start;
		align-items: flex-end;
		flex-wrap: wrap;
		text-align: left;
		border-bottom-right-radius: 20px;
	}

	.header-gift h4:nth-child(1){
		margin-bottom: 0 !important;
		color: #fff;
		font-size: 15px;
		font-weight: 500;
		font-family: 'Poppins', sans-serif;
		width: 100%;
	}

	.header-gift h4:nth-child(2){
		color: #fff;
		font-size: 20px;
		font-weight: 600;
		font-family: 'Poppins', sans-serif;
		width: 100%;
	}

	.order-owner{
		width: 100%;
		padding: 16px 15px;
		text-align: left;
	}

	.order-owner h4{
		font-size: 20px;
		font-weight: 500;
		font-family: 'Poppins', sans-serif;
		margin-bottom: 0 !important;
	}

	.data-receptor{
		width: 100%;
		padding: 0px 15px;
	}

	.data-receptor input {
		padding: 13px;
		border-top-left-radius: 22px;
		border-bottom-right-radius: 22px;
		border-bottom-left-radius: 22px;
		border: 2px solid #12243C;
		background: #f3f3f3;
		font-size: 15px;
	}

	.data-name{
		width: 100%;
		margin-bottom: 13px;
	}

	.phone-day{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 13px;
	}

	.data-phone{
		width: 49%;
	}

	.data-deliver-day{
		width: 49%;
	}

	.data-address{
		width: 100%;
		margin-bottom: 13px;
	}

	.data-place{
		width: 45%;
	}

	.data-clock{
		width: 53%;
	}

	.place-hour{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 13px;
	}

	.data-message{
		width: 100%;
		height: 70px;
		margin-bottom: 13px;
	}

	.options-buttons{
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top:18px; 
	}

	.options-buttons button{
		border: none;
		background: transparent;
		font-family: 'Poppins', sans-serif;
		font-size: 18px;
	}

	.back-btn{
		width: 40%;
		padding: 17px 0px;
	}

	.finish-order{
		width: 60%;
		padding: 17px 0px;
		border-top-left-radius: 35px;
	}

	.finish-order button{
		color: #fff;
	}


	.inputGroup2 {
	    background-color: #fff;
	    display: block;
	    margin: 0;
	    position: relative;
	    width: 30%;
	    label {
	      padding: 12px 30px;
	      width: 100%;
	      display: block;
	      text-align: left;
	      color: #3C454C;
	      font-size: 16px;
	      font-family: 'Poppins', sans-serif;
	      cursor: pointer;
	      position: relative;
	      z-index: 2;
	      transition: color 200ms ease-in;
	      overflow: hidden;

	      &:before {
	        width: 10px;
	        height: 10px;
	        border-radius: 50%;
	        content: '';
	        background-color: #5562eb;
	        position: absolute;
	        left: 50%;
	        top: 50%;
	        transform: translate(-50%, -50%) scale3d(1, 1, 1);
	        transition: all 300ms cubic-bezier(0.4, 0.0, 0.2, 1);
	        opacity: 0;
	        z-index: -1;
	      }

	      &:after {
	        width: 32px;
	        height: 32px;
	        content: '';
	        border: 2px solid #D1D7DC;
	        background-color: #fff;
	        background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.414 11L4 12.414l5.414 5.414L20.828 6.414 19.414 5l-10 10z' fill='%23fff' fill-rule='nonzero'/%3E%3C/svg%3E ");
	        background-repeat: no-repeat;
	        background-position: 2px 3px;
	        border-radius: 50%;
	        z-index: 2;
	        position: absolute;
	        right: 10px;
	        top: 50%;
	        transform: translateY(-50%);
	        cursor: pointer;
	        transition: all 200ms ease-in;
	      }
	    }

	    input:checked ~ label {
	      color: #000;

	      &:before {
	        transform: translate(-50%, -50%) scale3d(56, 56, 1);
	      }

	      &:after {
	        background-color: #54E0C7;
	        border-color: #54E0C7;
	      }
	    }

	    input {
	      width: 32px;
	      height: 32px;
	      order: 1;
	      z-index: 2;
	      position: absolute;
	      right: 30px;
	      top: 50%;
	      transform: translateY(-50%);
	      cursor: pointer;
	      visibility: hidden;
	    }
  }

  .check-name{
  	width: 100%;
  	display: flex;
  	align-items: center;
  	justify-content: flex-start;
  	flex-wrap: wrap;
  	text-align: left;
  }

  .check-name h4{
  	width: 100%;
  	font-size: 16px;
  	font-family: 'Poppins', sans-serif;
  	font-weight: 500;
  	margin-bottom: 0 !important;
  }

  .send-image{
  	width: 100%;
  	display: flex;
  	justify-content: flex-start;
  	align-items: center;
  	padding: 5px 0px;
  }

  .send-image h4{
  	margin-bottom: 0 !important;
  	font-family: 'Poppins', sans-serif;
  	font-size: 16px;
  }

  .send-image i{
  	color: #fff;
  	font-size: 17px;
  	margin-right: 5px;
  }


</style>

<script>
	import $ from 'jquery'
	export default {
		data(){
			return {
				modelo: "",
				reciber_hour: JSON.parse(localStorage.getItem('hora_entrega')),
				send_nombre: localStorage.getItem('nombre'),
				form:{
					reciber_name: '',
					reciber_phone: '',
					delivery_day: '',
					reciber_adress: '',
					reciber_place: '',
					delivery_hour: null,
					delivery_message: '',
					imagen: '',
					firm: true,
					nofirm: false,
				},
				statusImagen: false,
				color_licencia: localStorage.getItem('color_licencia'),
				show_image: false
			}
		},
		methods:{
			key: function(event) {
          		//this.modelo = 'key ' + event.key + ' (' + event.keyCode + ')';
          		let tamaño = this.form.delivery_message.split(" ");
          		if (tamaño.length > 15) {
          			if(event.keyCode >= 65 && event.keyCode <= 90){
          				this.disable();
          				document.getElementById("limit").style.display = '';
          			}else{
          				this.enable();
          				document.getElementById("limit").style.display = 'none';
          			}
          		}else{
          			document.getElementById("limit").style.display = 'none';
          		}
          		
     		},
			confirmOrder(){	
				if (this.validateShields()) {
					this.$emit('giftProduct', this.form);
				}
			},
			disable(){
				document.onkeydown = function (e){
				  return false;
				}
			},
			enable(){
				document.onkeydown = function (e){
				  return true;
				}
			},
			uploadImage(){
				this.statusImagen = false;
				this.form.imagen = $('#file').prop("files")[0];
				if(this.form.imagen){
					this.statusImagen = true;
				}else{
					this.form.imagen = "";
				} 						
			},
			deleteImage(){
				document.getElementById('file').value = null;				
				this.uploadImage();
			},
			validateShields(){
  				let status = true;
  				
  				if(!this.form.reciber_name){
  					$("#name").addClass('empty-shield');status = false;		
  				}else {
  					$("#name").removeClass('empty-shield');	
  				}
  				
  				if(!this.form.reciber_phone){
  					$("#phone").addClass('empty-shield');status = false;		
  				}else {
  					$("#phone").removeClass('empty-shield');	
  				}

  				if(!this.form.delivery_day){
  					$("#day").addClass('empty-shield');status = false;		
  				}else {
  					$("#day").removeClass('empty-shield');	
  				}

  				if(!this.form.reciber_adress){
  					$("#addreess").addClass('empty-shield');status = false;		
  				}else {
  					$("#addreess").removeClass('empty-shield');	
  				}

  				if(!this.form.reciber_place){
  					$("#barrio").addClass('empty-shield');status = false;		
  				}else {
  					$("#barrio").removeClass('empty-shield');	
  				}

  				if(!this.form.delivery_hour && this.reciber_hour){
  					$("#hour").addClass('empty-shield');status = false;		
  				}else {
  					$("#hour").removeClass('empty-shield');	
  				}

  				if(!this.form.delivery_message){
  					$("#message").addClass('empty-shield');status = false;		
  				}else {
  					$("#message").removeClass('empty-shield');	
  				}

  				return status;	
  			},
			clearForm() {
		      Object.keys(this.form).forEach(v => (this.form[v] = ""));
		    },
		    back(){
		    	this.$emit('closeGift', false);
		    }
		},
		mounted(){
			document.getElementById("limit").style.display = 'none';
			if(localStorage.getItem('imagen_gift') == "true" ? this.show_image = true : this.show_image = false);
			if(!this.reciber_hour){
				$("#barrio").addClass('no-reciber-hour');
			}else{
				$("#barrio").removeClass('no-reciber-hour');
			}
		}	
	}
</script>